export default "__VITE_ASSET__3FXVOmwo__"